const zh_hk = {
  common: {
    home: "首頁",
    notGuest: "不是 {{name}}？",
    goHome: "返回首頁",
    save: "儲存",
    cancel: "取消",
    create: "新增",
    update: "更新",
    delete: "刪除",
    back: "返回",
    all: "全部",
    yes: "是",
    no: "否",
    maybe: "未定",
    menu: "選單",
    inputAdjusted: "已移除無法儲存的字元。",
  },
  visitor: {
    browsing: "你正以訪客身份瀏覽",
    identify: "請告訴我們你是誰",
  },
  home: {
    welcome: "歡迎蒞臨我們的婚禮",
    hello: "你好，{{name}}！",
    switchGuest: "不是 {{name}}？切換",
    tagline: "我們特別的一天所需的一切",
    identify: "請告訴我們你是誰",
    invitation: "請柬",
    invitationDesc: "查看您的婚禮請柬並回覆出席",
    programme: "程序表",
    programmeDesc: "查看婚禮當天的時間表",
    gallery: "相簿",
    galleryDesc: "瀏覽婚禮的照片和影片",
    upload: "上載",
    uploadDesc: "分享您當天拍攝的照片和影片",
    countdown: {
      years: "年",
      months: "月",
      days: "天",
      hours: "時",
      minutes: "分",
      seconds: "秒",
      untilWedding: "距離婚禮還有",
      weddingDay: "今天就是大日子！",
      weddingPassed: "感謝您與我們一起慶祝！",
    },
  },
  identify: {
    title: "請問你是？",
    subtitle: "請選擇您的名字以便我們為您提供個人化體驗",
    currentlyIdentified: "您目前的身份為 <strong>{{name}}</strong>",
    noGuests: "此群組中沒有賓客",
    searchPlaceholder: "以姓名搜尋",
    noSearchResults: "找不到相符的賓客",
  },
  invitation: {
    togetherWithFamilies: "偕同家人",
    requestPleasure: "誠邀",
    atCelebration: "出席婚禮慶典",
    kindlyRespond: "敬請回覆",
    visitorName: "各位嘉賓",
    notFound: "找不到請柬。請檢查您的連結。",
  },
  rsvp: {
    title: "出席回覆",
    trackIndividually: "逐一回覆？",
    attending: "是否出席？",
    willAttend: "請問您會出席嗎？",
    yesAttending: "會，我會出席！",
    notAttending: "抱歉，未能出席",
    notSure: "尚未確定",
    guestCount: "出席人數：",
    whoIsComing: "誰會出席？",
    selectAtLeastOne: "請至少選擇一位賓客。",
    dietary: "飲食需求",
    messageOptional: "留言（選填）",
    messageCouple: "給新人的話（選填）",
    submit: "提交回覆",
    submitting: "提交中⋯",
    submitFailed: "提交回覆失敗",
    submitFailedFor: "提交 {{name}} 的回覆失敗",
  },
  confirmation: {
    thankYou: "謝謝您！",
    received: "已收到您的回覆。我們期待與您一同慶祝！",
    updateRsvp: "更新回覆",
  },
  gallery: {
    title: "婚禮相簿",
    noMedia: "暫無媒體",
    video: "影片",
  },
  upload: {
    title: "分享您的美好時刻",
    subtitle: "上傳您在婚禮中拍攝的照片和影片",
    yourName: "您的名字",
    autoFilled: "已從您的身份自動填入",
    category: "類別",
    preWedding: "婚前準備",
    ceremony: "儀式",
    reception: "宴會",
    party: "派對",
    other: "其他",
    dragDrop: "拖放檔案到此處",
    clickBrowse: "或點擊瀏覽",
    maxSize: "每個圖片和影片最大 50 MB",
    uploaded: "已上傳",
    uploadCount: "上傳 {{count}} 個檔案",
    uploadCount_other: "上傳 {{count}} 個檔案",
    allUploaded: "所有檔案已成功上傳！感謝您的分享。",
  },
  programme: {
    title: "當日程序",
    subtitle: "我們特別的一天流程",
  },
  notFound: {
    title: "找不到頁面",
    message: "請檢查連結後再試一次。",
  },
  invitationNotFound: {
    title: "找不到請柬",
    message: "請檢查請柬中的連結後再試一次。",
  },
  admin: {
    panel: "管理面板",
    weddingAdmin: "婚禮管理",
    wa: "婚管",
    login: {
      title: "婚禮管理",
      subtitle: "使用管理員帳號登入",
      email: "電郵",
      password: "密碼",
      signIn: "登入",
      sessionEnded: "登入已逾時",
      sessionEndedHint: "請重新登入以保留此頁。已輸入的內容仍在。",
      staySignedIn: "保持登入",
      staySignedInHint: "此頁已閒置一段時間，登入即將結束。",
    },
    logout: "登出",
    nav: {
      dashboard: "儀表板",
      guests: "賓客",
      invitations: "請柬",
      programme: "程序表",
      media: "媒體",
      settings: "設定",
      sitePhotos: "網站照片",
      locale: "語言",
      categories: "分類",
    },
    dashboard: {
      title: "儀表板",
      totalGuests: "賓客總數",
      invitations: "請柬",
      rsvps: "回覆",
      mediaFiles: "媒體檔案",
      rsvpBreakdown: "回覆統計",
      attending: "出席：",
      notAttending: "不出席：",
      maybe: "未定：",
      confirmedGuestCount: "已確認賓客人數",
      guestsConfirmed: "位賓客已確認",
    },
    settings: {
      title: "設定",
      guestDetailLevel: "賓客詳細程度",
      guestDetailLevelTooltip:
        "控制如何追蹤出席情況——按團體、按個人成員，或讓每個團體自行選擇。",
      partyLevel: "團體級別 — 僅按團體追蹤出席情況",
      memberLevel: "成員級別 — 追蹤每個團體中的個人成員",
      flexible: "彈性 — 讓每個團體選擇偏好",
      defaultMode: "團體預設模式",
      party: "團體",
      member: "成員",
      defaultLanguage: "預設語言",
      defaultLanguageTooltip: "當無法偵測訪客裝置語言時使用的語言。",
      english: "English",
      chinese: "繁體中文",
      coupleNames: "新人名字",
      coupleNamesZh: "新人名字（中文）",
      weddingVenue: "婚禮場地",
      weddingVenueZh: "婚禮場地（中文）",
      mediaCategories: "媒體分類",
      mediaCategoriesDescription:
        "媒體上傳可用的分類。更改適用於新上傳和分類編輯。",
      addCategory: "新增分類",
      categoryExists: "分類已存在",
      categoryAdded: "分類已新增",
      categoryRemoved: "分類已移除",
      idleTimeout: "管理員閒置逾時",
      idleTimeoutTooltip: "管理員在多少分鐘內沒有請求便會結束登入。賓客瀏覽不受影響。",
      idleTimeoutMinutes: "分鐘",
      idleTimeoutInvalid: "請輸入 5 至 10080 的整數。",
      idleTimeoutSaved: "已儲存閒置逾時",
      visitorMode: "訪客模式",
      visitorModeTooltip: "開啟後，賓客無需選擇名字即可瀏覽每個頁面。上載時需要輸入名字。",
    },
    guests: {
      title: "賓客",
      orderHint: "排序只作用於同一群組內，賓客確認身份時會按此順序顯示。",
      selectGroupPrompt: "請先在群組樹選擇要編輯的群組。",
      noPartiesInGroup: "此群組沒有賓客。",
      maxAttendeesTooLow: "最多出席人數不能少於成員人數。",
      addGuest: "新增賓客",
      editGuest: "編輯賓客",
      name: "名字",
      nameZh: "名稱（中文）",
      invitationCardName: "邀請卡文字",
      invitationCardNameZh: "邀請卡文字（中文）",
      invitationCardNameHint:
        "顯示在該語言的邀請卡上。邀請卡文字留空則使用同一語言的團體名稱。若也留空，則使用另一語言的邀請卡文字，最後才使用另一語言的團體名稱。",
      nameRequired: "請輸入英文或中文名稱",
      group: "群組",
      maxAttendees: "最多出席人數",
      attending: "出席",
      count: "人數",
      dietary: "飲食",
      message: "留言",
      device: "裝置",
      responded: "已回覆",
      groups: "群組",
      addGroup: "新增群組",
      editGroup: "編輯群組",
      noGroup: "（無群組）",
      detailLevel: "詳細程度",
      members: "成員",
      addMember: "新增成員",
      editMember: "編輯成員",
      memberName: "成員名字",
      memberNameZh: "成員名稱（中文）",
      dietaryPreferences: "飲食偏好",
      confirmDelete: "確定要刪除此賓客嗎？",
      confirmDeleteGroup: "確定要刪除此群組嗎？",
      confirmDeleteMember: "確定要刪除此成員嗎？",
      parentGroup: "上級群組",
      none: "無",
      moveUp: "上移",
      moveDown: "下移",
      dragToReorder: "拖曳以排序",
      copyCode: "複製代碼",
      email: "電郵",
      phone: "電話",
      notes: "備註",
      manageGroups: "管理群組",
      addRootGroup: "新增根群組",
      memberRsvps: "成員回覆",
      actions: "操作",
      detailLevelFlexible: "詳細程度（彈性模式）",
      useDefault: "使用預設",
      partyMembers: "團體成員",
      newMemberName: "新成員名字",
      deletedGroup: "已刪除群組",
      groupDeletedReassign: "群組已被刪除，請重新分配此賓客。",
      nonLeafReassign: "賓客分配到非末端群組，請重新分配。",
      seeMembers: "（見成員）",
      icon: "圖示",
      iconNone: "無",
      iconEmoji: "表情符號",
      iconReact: "React 圖示",
      iconSvg: "SVG",
      iconImage: "圖片",
      iconReactName: "圖示名稱，例如 GiDiamondRing",
      iconReactMissing: "找不到此圖示",
      iconSvgInvalid: "不接受此 SVG",
      iconImageNeedsSave: "請先儲存，再上載圖片",
      iconClear: "清除圖示",
      iconUpload: "上載圖片",
    },
    invitations: {
      title: "請柬",
      generate: "生成連結",
      generateAll: "全部生成",
      code: "代碼",
      guest: "賓客",
      status: "狀態",
      link: "連結",
      copyLink: "複製連結",
      copied: "已複製！",
      sent: "已發送",
      pending: "待處理",
      opened: "已開啟",
    },
    programme: {
      title: "程序表",
      addEvent: "新增活動",
      editEvent: "編輯活動",
      eventTitle: "標題",
      description: "描述",
      startTime: "開始時間",
      endTime: "結束時間",
      location: "地點",
      sortOrder: "排序",
      titleZh: "標題（中文）",
      descriptionZh: "描述（中文）",
      hide: "隱藏",
      hidden: "已隱藏",
      showOnInvitation: "顯示於請柬",
      onInvitation: "請柬",
      hiddenOffInvitation: "已隱藏的活動不會出現在請柬上。",
    },
    media: {
      title: "媒體",
      approve: "批准",
      reject: "拒絕",
      deleteSelected: "刪除選取",
      pending: "待審核",
      approved: "已批准",
      rejected: "已拒絕",
      uploadedBy: "上傳者",
      category: "類別",
      noMedia: "暫無媒體檔案",
      search: "搜尋檔案名稱或賓客",
      filterCategory: "類別",
      filterStatus: "狀態",
      filterModeration: "審核",
      allCategories: "所有類別",
      allStatuses: "所有狀態",
      allModeration: "全部",
      showHidden: "顯示隱藏",
      featuredOnly: "僅精選",
      preview: "預覽",
      download: "下載",
      downloadZip: "下載壓縮檔",
      copyUrl: "複製連結",
      urlCopied: "連結已複製到剪貼簿",
      editCategory: "編輯類別",
      regenerateThumbnail: "重新生成縮圖",
      delete: "刪除",
      confirmDelete: "確定要刪除此媒體嗎？",
      confirmBulkDelete: "確定要刪除 {{count}} 個選取項目嗎？",
      toggleFeatured: "切換精選",
      toggleHidden: "切換隱藏",
      featured: "精選",
      hidden: "隱藏",
      visible: "可見",
      bulkChangeCategory: "更改類別",
      bulkApprove: "批准選取",
      bulkReject: "拒絕選取",
      nSelected: "已選取 {{count}} 項",
      clearSelection: "清除選取",
      noResults: "找不到結果",
      totalFiles: "檔案總數",
      totalSize: "總大小",
      storageUsed: "已用儲存空間",
      storageQuota: "共 {{quota}} GB",
      pendingModeration: "待審核",
      stuckUploads: "卡住的上傳",
      stuckAlert: "{{count}} 個上傳卡住或失敗",
      cleanUp: "清理",
      cleanedUp: "已清理 {{count}} 個卡住的上傳",
      uploadTimeline: "上傳時間線",
      topUploaders: "上傳排行榜",
      mediaTypes: "媒體類型",
      recentActivity: "最近活動",
      guest: "賓客",
      uploads: "上傳數",
      size: "大小",
      file: "檔案",
      type: "類型",
      status: "狀態",
      moderation: "審核",
      uploaded: "上傳時間",
      actions: "操作",
      image: "圖片",
      video: "影片",
      other: "其他",
      dashboard: "儀表板",
      table: "列表",
      timeAgo: "{{time}} 前",
      deletedSuccess: "媒體已刪除",
      bulkDeletedSuccess: "已刪除 {{count}} 個項目",
      bulkUpdatedSuccess: "已更新 {{count}} 個項目",
      categoryUpdated: "類別已更新",
      moderationUpdated: "審核狀態已更新",
      thumbnailRegenerated: "縮圖已重新生成",
      featuredUpdated: "精選狀態已更新",
      hiddenUpdated: "可見度已更新",
    },
    locale: {
      title: "編輯翻譯",
      subtitle: "欄位顯示賓客及管理介面目前使用的文字。編輯欄位即可覆寫。",
      search: "搜尋鍵值或文字⋯",
      key: "鍵值",
      english: "英文",
      chinese: "繁體中文",
      default: "預設",
      resetToDefault: "重設為預設值",
      saved: "翻譯已儲存",
      saveFailed: "儲存翻譯失敗",
      modified: "已修改",
      noResults: "找不到符合的鍵值",
      variables: "變數",
    },
    sitePhotos: {
      title: "網站照片",
      subtitle: "上傳照片裝飾您的婚禮網站頁面",
      homeLogo: "網站圖示及賓客頁首標誌",
      homeHero: "首頁橫幅",
      homeBg: "首頁背景",
      homeCardInvitation: "首頁請柬按鈕背景",
      homeCardProgramme: "首頁程序表按鈕背景",
      homeCardGallery: "首頁相簿按鈕背景",
      homeCardUpload: "首頁上載按鈕背景",
      invitationCouple: "請柬情侶照片",
      invitationCardBg: "請柬卡片背景",
      programmeHeader: "程序表橫幅",
      programmeBg: "程序表背景",
      galleryBg: "相簿背景",
      uploadBg: "上載頁背景",
      uploadPhoto: "上傳照片",
      replacePhoto: "替換",
      removePhoto: "移除",
      noPhoto: "未設置照片",
      eventPhoto: "程序表活動照片",
    },
  },
} as const;

export default zh_hk;
